import VGCatalog from "../catalog/catalog";
import axios from "axios";

class VGCatalogOrder extends VGCatalog {
	constructor() {
		super();
	}

	make($form, callback) {
		let route = $form.getAttribute('action'),
			params = new FormData($form);

		axios.post(route, params).then((response) => {
			if (typeof callback === "function") {
				return callback(response.data);
			}
		});
	}
}

export default VGCatalogOrder;
